<template>
  <div>
    <ViewTemplateReportList :panel="panel" :reports="reports" />
  </div>
</template>

<script>
import ViewTemplateReportList from "@nixweb/nixloc-ui/src/component/template/ViewTemplateReportList";

export default {
  name: "ReportRentalView",
  components: { ViewTemplateReportList },
  data() {
    return {
      panel: {
        module: "Locação",
        title: "Relatório",
        showFilter: false,
        showSearch: true,
        showButtons: false,
      },
      reports: {
        default: [
          {
            name: "Locação por Cliente",
            routeName: "reportRentByCustomer",
          },
          {
            name: "Locação por Período",
            routeName: "reportRentByPeriodRent",
          },
          {
            name: "Locação por Produto",
            routeName: "reportRentByProduct",
          },
          {
            name: "Pagamento por Locação",
            routeName: "reportRentByPayment",
          },
        ],
        saved: [],
      },
    };
  },
};
</script>
